module.exports = __webpack_public_path__ + "static/media/only-bridge.35f80ac7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/only-bridge.png
 ** module id = 593
 ** module chunks = 0
 **/